var _rect, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmarksThumbnail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#F0DDBA",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item-2",
    d: "M101 78V91C101 96.5228 96.5228 101 91 101H28.5C28.5 97.8 33 91 38.45 88.5C44.315 85 54.63 87.5 68.085 88.5C78.849 89.3 93.41 81.8333 101 78Z",
    fill: "#E6D4B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item-2",
    d: "M1 20L1 11C1 5.47715 5.47715 1 11 1L84 1.00001C84 4.20001 67.3283 8.74579 64.5 9.5C57 11.5 47.37 10.5 33.915 9.5C23.151 8.7 8.59 16.1667 1 20Z",
    fill: "#E6D4B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item",
    d: "M1 82V91C1 96.5228 5.47715 101 11 101H92C92 97.8 88.6333 94 86.95 92.5C78.365 89 74.73 91.5 55.035 92.5C39.279 93.3 12.11 85.8333 1 82Z",
    fill: "#E0C99D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background-item",
    d: "M101 15L101 11C101 5.47715 96.5228 1 91 0.999999L13 0.999991C13.5 4 13.3667 2.99999 15.05 4.49999C23.635 7.99999 27.27 5.49999 46.965 4.5C62.721 3.7 89.89 11.1667 101 15Z",
    fill: "#E0C99D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5792,
    cy: 50.8556,
    rx: 14.4804,
    ry: 14.4574,
    transform: "rotate(90 25.5792 50.8556)",
    fill: "#354774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9436 75.1477C79.8069 75.1477 76.4518 71.7886 76.4518 67.6431C76.4518 63.4976 79.8069 60.1386 83.9436 60.1386C88.0804 60.1386 91.4354 63.4976 91.4354 67.6431C91.4354 71.7886 88.0804 75.1477 83.9436 75.1477Z",
    fill: "#F8F2E4",
    stroke: "#18171D",
    strokeWidth: 1.12916
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6851 68.3732C85.5479 67.509 86.9407 67.4897 87.8271 68.3296L90.7905 71.1374C90.7905 71.1374 89.9453 72.3249 89.3086 73.0035C88.7052 73.6466 87.64 74.5246 87.64 74.5246L84.6851 71.5652C83.8051 70.6838 83.805 69.2547 84.6851 68.3732Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9436 25.2388C79.8069 25.2388 76.4518 28.5978 76.4518 32.7433C76.4518 36.8888 79.8069 40.2479 83.9436 40.2479C88.0804 40.2479 91.4354 36.8889 91.4354 32.7433C91.4354 28.5978 88.0804 25.2388 83.9436 25.2388Z",
    fill: "#F8F2E4",
    stroke: "#18171D",
    strokeWidth: 1.12916
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6851 32.0123C85.5479 32.8764 86.9407 32.8958 87.8271 32.0559L90.7905 29.2481C90.7905 29.2481 89.9453 28.0606 89.3086 27.382C88.7052 26.7388 87.64 25.8609 87.64 25.8609L84.6851 28.8203C83.8051 29.7017 83.805 31.1308 84.6851 32.0123Z",
    fill: "#1E1E1E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.7584,
    cy: 50.3949,
    rx: 20.2738,
    ry: 20.2416,
    transform: "rotate(90 71.7584 50.3949)",
    fill: "#354774"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4494 37.6061C78.2055 41.8525 79.1094 46.4037 79.1094 51L44.1649 51L22.7138 51L22.7144 50.9997L10.0001 43.6475C10.4424 41.5858 11.0708 39.5636 11.8803 37.6061C13.6365 33.3597 16.2105 29.5013 19.4554 26.2513C22.7003 23.0012 26.5525 20.4231 30.7922 18.6642C35.0318 16.9053 39.5759 16 44.1649 16C48.7538 16 53.2979 16.9053 57.5375 18.6642C61.7772 20.4231 65.6295 23.0012 68.8744 26.2513C72.1193 29.5013 74.6933 33.3597 76.4494 37.6061Z",
    fill: "#3D8B97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7143 51.0002L9.99962 58.3527C10.4419 60.4144 11.0703 62.4366 11.8799 64.3942C13.636 68.6405 16.21 72.4989 19.4549 75.749C22.6998 78.999 26.552 81.5771 30.7917 83.336C35.0314 85.0949 39.5754 86.0002 44.1644 86.0002C48.7534 86.0002 53.2974 85.0949 57.5371 83.336C61.7767 81.5771 65.629 78.999 68.8739 75.749C72.1188 72.4989 74.6928 68.6406 76.4489 64.3942C78.205 60.1478 79.1089 55.5965 79.1089 51.0002L44.1644 51.0002L22.7143 51.0002Z",
    fill: "#056A81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5709 50.9773C66.5711 51.0172 66.5712 51.0571 66.5712 51.0971C66.5712 60.9454 62.3826 69.7848 55.7421 75.8245C64.3673 71.1246 70.2451 61.7808 70.2451 51.0213C70.2451 51.0066 70.2451 50.992 70.2451 50.9773L66.5709 50.9773Z",
    fill: "#F5C58A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9353 50.9773C51.9354 51.008 51.9354 51.0387 51.9354 51.0694C51.9354 58.645 48.6838 65.4446 43.5287 70.0905C50.2245 66.4752 54.7876 59.2877 54.7876 51.0111C54.7876 50.9999 54.7876 50.9886 54.7876 50.9773L51.9353 50.9773Z",
    fill: "#F5C58A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5882 50.7859C36.5883 50.8055 36.5883 50.8252 36.5883 50.8449C36.5883 55.6932 34.5491 60.045 31.3163 63.0184C35.5154 60.7045 38.377 56.1045 38.377 50.8076C38.377 50.8003 38.377 50.7931 38.377 50.7859L36.5882 50.7859Z",
    fill: "#F5C58A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5709 50.9773C66.5711 50.9389 66.5712 50.9005 66.5712 50.8621C66.5712 41.3926 62.3826 32.8931 55.7421 27.0857C64.3673 31.6049 70.2451 40.5893 70.2451 50.935C70.2451 50.9491 70.2451 50.9632 70.2451 50.9773L66.5709 50.9773Z",
    fill: "#F1AE5B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9353 50.9773C51.9354 50.9472 51.9354 50.9171 51.9354 50.887C51.9354 43.4629 48.6838 36.7993 43.5287 32.2463C50.2245 35.7894 54.7876 42.8331 54.7876 50.9441C54.7876 50.9552 54.7876 50.9662 54.7876 50.9773L51.9353 50.9773Z",
    fill: "#F1AE5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5882 50.7859C36.5883 50.7672 36.5883 50.7484 36.5883 50.7297C36.5883 46.1086 34.5491 41.9608 31.3163 39.1268C35.5154 41.3322 38.377 45.7166 38.377 50.7652C38.377 50.7721 38.377 50.779 38.377 50.7859L36.5882 50.7859Z",
    fill: "#F1AE5B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.002,
    y: 67.4148,
    width: 15.2906,
    height: 15.2664,
    rx: 7.13229,
    transform: "rotate(90 42.002 67.4148)",
    fill: "#E06351"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.002,
    y: 19.0586,
    width: 15.2906,
    height: 15.2664,
    rx: 7.13229,
    transform: "rotate(90 42.002 19.0586)",
    fill: "#F1AE5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmarksThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LandmarksThumbnail.1aa67b0753ab0449dfb9696e8c3d3b6f.svg";